import { ImageOff } from 'lucide-react';
import { imageSrc } from '../agreementFormat';

// A page of the client document: letter-shaped paper, the brand's footer lines and the page number.
export function Paper({ brand, n, total, bleed = false, children, tid }) {
  return (
    <article className="relative flex aspect-[8.5/11] w-full flex-col bg-white shadow-[0_18px_40px_-24px_rgba(13,27,42,0.55)] ring-1 ring-[#D5D8DD]" data-testid={tid}>
      <div className={`flex-1 ${bleed ? '' : 'px-[9%] pt-[9%]'}`}>{children}</div>
      <footer className="mx-[9%] mb-[5%] mt-6 flex items-end justify-between gap-3 border-t pt-2 text-[9px] text-[#5C6370]" style={{ borderColor: brand.accent }}>
        <span className="min-w-0 space-y-px">{(brand.footer.length ? brand.footer : [brand.company]).map((l, i) => <span key={i} className="block truncate">{l}</span>)}</span>
        {brand.look?.show?.page_numbers !== false && <span className="shrink-0 tabular-nums">{n} / {total}</span>}
      </footer>
    </article>
  );
}

export function PageTitle({ brand, eyebrow, title }) {
  return (
    <div className="mb-5 space-y-1">
      {eyebrow && <p className="text-[9px] font-semibold uppercase tracking-[0.22em]" style={{ color: brand.accent }}>{eyebrow}</p>}
      <h2 className="font-exo text-xl font-bold leading-tight" style={{ color: brand.primary }}>{title}</h2>
      <span className="block h-0.5 w-10" style={{ background: brand.accent }} />
    </div>
  );
}

// A focal point {x, y} (fractions from the top-left) as a CSS position; none = the middle.
export const focusPosition = (f) => (f ? `${+(f.x * 100).toFixed(1)}% ${+(f.y * 100).toFixed(1)}%` : '50% 50%');

// An empty slot shows as a dashed placeholder here (the preview); a filled one is the photo itself, cropped around its
// focal point when it has one (the default cover's).
export function Photo({ ph, className = '', tid }) {
  if (ph?.src) {
    return <img src={imageSrc(ph.src)} alt="" className={`h-full w-full object-cover ${className}`} data-testid={tid}
      style={ph.focus ? { objectPosition: focusPosition(ph.focus) } : undefined} />;
  }
  return (
    <span className={`flex h-full w-full flex-col items-center justify-center gap-1 border border-dashed border-amber-400 bg-amber-50/60 text-[10px] font-semibold text-amber-800 ${className}`} data-testid={tid}>
      <ImageOff className="h-4 w-4" />Empty photo slot
    </span>
  );
}

export function PhotoGrid({ photos, tid }) {
  if (!photos?.length) return null;
  const cols = photos.length === 1 ? 'grid-cols-1' : 'grid-cols-2';
  return (
    <div className={`grid gap-2 ${cols}`} data-testid={tid}>
      {photos.map((ph, i) => (
        <div key={i} className={`overflow-hidden rounded-[2px] ${photos.length === 1 ? 'aspect-[16/10]' : 'aspect-[4/3]'}`}><Photo ph={ph} tid={`${tid}-${i}`} /></div>
      ))}
    </div>
  );
}
